export const VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST = "VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST";
export const VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS = "VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS";
export const VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR = "VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR";

